export const OFFLINE_ACCOUNT_KEY = 'upya.offline.provisionedAccount';

// Reader eligibility is separate from server authorization. A stored token alone
// never provisions an offline account; only successful online verification does.
export async function resolveOfflineSession({ nativeAndroid, userId, provisionedUserId, error, hasCachedConversations, hasVisibleMessages = false }) {
  const status = error?.response?.status;
  // auth-api authenticateToken uses this exact 403 response for invalid/expired JWTs.
  // Other 403 responses remain access refusals, never offline-session fallbacks.
  const rejectedToken = status === 403 && error?.response?.data?.error === 'Token invalide ou expiré.';
  const sessionExpired = !error || status === 401 || rejectedToken;
  const eligibleFailure = !status || status === 401 || rejectedToken || status >= 500;
  if (!nativeAndroid || !userId || String(userId) !== provisionedUserId || !eligibleFailure) {
    return { allowed: false, sessionExpired };
  }
  try {
    return { allowed: hasVisibleMessages || await hasCachedConversations(userId), sessionExpired };
  } catch {
    return { allowed: false, sessionExpired };
  }
}
